module.exports = __webpack_public_path__ + "img/hero.dac0f006.png";